import { render, staticRenderFns } from "./theFaresLounge.vue?vue&type=template&id=3af93740&scoped=true&"
import script from "./theFaresLounge.vue?vue&type=script&lang=js&"
export * from "./theFaresLounge.vue?vue&type=script&lang=js&"
import style0 from "./theFaresLounge.vue?vue&type=style&index=0&id=3af93740&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af93740",
  null
  
)

export default component.exports